import { LightMode } from "@repo/skapa";
import { Text } from "@repo/skapa";
import { T } from "@repo/translation";
import { CoWorkerName, LocalizedDateAndTime } from "@repo/ui";

export const NoteItemHistoryInfo = ({
  createdBy,
  createdAt,
  label = "label.created_by",
}: {
  createdBy?: string;
  createdAt: string;
  label?: string;
}) => {
  return (
    <div>
      <Text
        tagName="span"
        color={LightMode.colourTextAndIcon3}
        textStyle="Body.S"
      >
        <T translationKey={label} />:{" "}
      </Text>
      {createdBy?.toLowerCase() === "system" ? (
        <Text
          tagName="span"
          color={LightMode.colourTextAndIcon3}
          textStyle="Body.S"
        >
          <T translationKey="label.system" />
        </Text>
      ) : (
        <CoWorkerName
          email={createdBy}
          tagName="span"
          color={LightMode.colourTextAndIcon3}
          textStyle="Body.S"
        />
      )}
      <Text
        tagName="span"
        color={LightMode.colourTextAndIcon3}
        textStyle="Body.S"
      >
        {" | "}
      </Text>
      <Text
        tagName="span"
        color={LightMode.colourTextAndIcon3}
        textStyle="Body.S"
      >
        <LocalizedDateAndTime date={createdAt} />
      </Text>
    </div>
  );
};
